import Pagination from 'react-js-pagination'
import './style.css'

const PaginatedTable = ({id, itemsCountPerPage, totalItemsCount, getFunction, onClick, currentPage}) => {

    const pageRangeDisplayed = window.screen.width < 600 ? 2 : 5

    function handleChange(page) {
        if (getFunction) getFunction(page, itemsCountPerPage)
        if (onClick) onClick()
    }

    return (
        <div className='pagination-container' id={"pagination-"+id}>
            <Pagination
                itemClass='itemClass'
                innerClass='innerClass'
                linkClass="pageLink"
                activeClass="activeClass"
                activePage={currentPage}
                itemsCountPerPage={itemsCountPerPage}
                totalItemsCount={totalItemsCount}
                onChange={(pageNumber) => handleChange(pageNumber)}
                pageRangeDisplayed={pageRangeDisplayed}
                hideDisabled={totalItemsCount === 0}
            />
        </div>
    )
}

export default PaginatedTable;
